// General
import { useEffect } from "react";
// Services
import { useGenesisPurchaseMutation } from "../../../services/data.service";
import { spiApi } from "../../../services/data.service";
import { trackingService } from "../../../services/tracking.service";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateBuyCoinsDialog,
  updateCoinsPackageDialog,
  updateThankYouForPurchaseDialog,
  updatePaymentProcessDialog,
} from "../../../redux/store/dialogStore";
import { updateErrorToast } from "../../../redux/store/toastStore";

const useGenesisCoinsQuickPayment = () => {
  // API variables
  const [
    genesisPurchase,
    {
      data: genesisPurchaseData,
      error: genesisPurchaseErrorData,
      isLoading: genesisPurchaseLoading,
      isSuccess: genesisPurchaseSuccess,
      isError: genesisPurchaseError,
    },
  ] = useGenesisPurchaseMutation();

  // Redux variables
  const selectedCoinPackage = useSelector(
    (state) => state.products.selectedCoinPackage
  );
  const genesisCardDetail = useSelector(
    (state) => state.payment.genesisCardDetail
  );
  const paymentTag = useSelector((state) => state.payment.paymentTag);
  const dispatch = useDispatch();

  // Lifecycle | Check for update | Genesis Purchase API Response
  useEffect(() => {
    if (genesisPurchaseLoading) {
    } else if (genesisPurchaseSuccess) {
      dispatch(updatePaymentProcessDialog(false));

      switch (genesisPurchaseData?.status) {
        case 1:
          // Close buy coin dialog
          dispatch(updateBuyCoinsDialog(false));
          // Close coins package dialog
          dispatch(updateCoinsPackageDialog(false));
          // Open thank you dialog
          dispatch(updateThankYouForPurchaseDialog(true));

          trackingService.pushPurchaseEvent(
            genesisPurchaseData?.data?.currency,
            genesisPurchaseData?.data?.amount
          );
          // TagManager.dataLayer({
          //   dataLayer: {
          //     event: "PWA-CoinPurchase-success", // Do not change this, it will affect GTM and Insider
          //     category: "Purchase",
          //     action: "Quick Purchase Coins Actions",
          //     label: "Quick Purchase Coins Payment State - success",
          //     value: {},
          //     currency: genesisPurchaseData?.data?.currency,
          //     product_name: genesisPurchaseData?.data?.name,
          //     user_id: getProfileData?.data?.id_int,
          //     username: getProfileData?.data?.username,
          //     amount: genesisPurchaseData?.data?.amount,
          //   },
          // });

          dispatch({
            type: `${spiApi.reducerPath}/invalidateTags`,
            payload: ["CoinPayment"],
          });
          break;
        case -1:
          const errorToastObj = {
            message: genesisPurchaseData?.message,
            autoClose: 3000,
          };
          dispatch(updateErrorToast(errorToastObj));
        default:
          break;
      }
    } else if (genesisPurchaseError) {
    }
  }, [genesisPurchaseLoading, genesisPurchaseSuccess, genesisPurchaseError]);

  // Main Function
  const genesisQuickPaymentFlow = () => {
    submitPayment();
  };

  // Part 1 |
  const submitPayment = () => {
    const payload = {
      payment_tag: paymentTag || "navbar-landing",
      product_hash_id: selectedCoinPackage?.product_hash_id,
      payment_token: genesisCardDetail[0]?.token,
    };
    genesisPurchase(payload);

    dispatch(updatePaymentProcessDialog(true));
  };

  return genesisQuickPaymentFlow;
};

export default useGenesisCoinsQuickPayment;
